import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

/** Halo blanc au survol uniquement (demande produit) */
const whiteHoverHalo =
  "shadow-none hover:shadow-[0_0_16px_rgba(255,255,255,0.88),0_0_34px_rgba(255,255,255,0.45),0_0_52px_rgba(255,255,255,0.2)] transition-shadow duration-200 ease-out";

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: `bg-primary text-primary-foreground hover:bg-primary/90 ${whiteHoverHalo}`,
        destructive: `bg-destructive text-destructive-foreground hover:bg-destructive/90 ${whiteHoverHalo}`,
        outline: `border border-input hover:bg-accent hover:text-accent-foreground ${whiteHoverHalo}`,
        secondary: `bg-secondary text-secondary-foreground hover:bg-secondary/80 ${whiteHoverHalo}`,
        ghost: `shadow-none hover:bg-accent hover:text-accent-foreground ${whiteHoverHalo}`,
        link: "text-primary underline-offset-4 hover:underline shadow-none",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
